import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ContactoComponent } from './contacto/contacto.component';

import { NoticiasComponent } from './noticias/noticias.component';
import { NoticiaComponent } from './noticia/noticia.component';

import { EspectaculosComponent } from './espectaculos/espectaculos.component';

// import { CineComponent } from './cine/cine.component';
// import { ProgramacionComponent } from './programacion/programacion.component';

import { ActividadesComponent } from './actividades/actividades.component';
import { ActividadComponent } from './actividad/actividad.component';

import { ServiciosComponent } from './servicios/servicios.component';
import { ServicioComponent } from './servicio/servicio.component';

import { SalonesComponent } from './servicios/salones/salones.component';

import { PeliculasComponent } from './peliculas/peliculas.component';
import { PeliculaComponent } from './pelicula/pelicula.component';

import { MaratonesComponent } from './maratones/maratones.component';
import { MaratonComponent } from './maraton/maraton.component';

import { EspectaculoComponent } from './espectaculo/espectaculo.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'contacto', component: ContactoComponent },

  { path: 'noticias', component: NoticiasComponent },
  { path: 'noticia/:id', component: NoticiaComponent },

  { path: 'espectaculos', component: EspectaculosComponent },
  { path: 'espectaculo/:id', component: EspectaculoComponent },

  // { path: 'cine', component: CineComponent },
  // { path: 'programacion/:id', component: ProgramacionComponent },

  { path: 'peliculas', component: PeliculasComponent },
  { path: 'pelicula/:id', component: PeliculaComponent },

  { path: 'actividades', component: ActividadesComponent },
  { path: 'actividad/:id', component: ActividadComponent },

  { path: 'servicios', component: ServiciosComponent },
  { path: 'servicio/:id', component: ServicioComponent },

  { path: 'salones', component: SalonesComponent },

  { path: 'maraton/:id', component: MaratonComponent },
  { path: 'maratones', component: MaratonesComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
